module.exports = __webpack_public_path__ + "static/media/Loading2.b75d698d.gif";